module.exports = __webpack_public_path__ + "img/index42.d25c7192.png";